import { render, staticRenderFns } from "./GlobalWindow.vue?vue&type=template&id=b51b16fc&scoped=true&"
import script from "./GlobalWindow.vue?vue&type=script&lang=js&"
export * from "./GlobalWindow.vue?vue&type=script&lang=js&"
import style0 from "./GlobalWindow.vue?vue&type=style&index=0&id=b51b16fc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b51b16fc",
  null
  
)

export default component.exports